import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from 'svelte';
import { getLanguage, subscribeLanguageChange, t } from '../../i18n.ts';
import Button from '../svelte-button.svelte';
import DropdownMenu from '../svelte-dropdown-menu.svelte';

var root = $.from_html(`<span class="ui-symbol-kebab">...</span>`);
var root_1 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item lut-remove-menu-item svelte-1kasenj" role="menuitem"> </button>`, 1);
var root_2 = $.from_html(`<article data-lut-item="true" class="svelte-1kasenj"><div data-part="lut-thumb-wrap" class="svelte-1kasenj"><img data-part="lut-thumb" loading="lazy" class="svelte-1kasenj"/></div> <div data-part="lut-meta" class="svelte-1kasenj"><div data-part="lut-name" class="svelte-1kasenj"> </div> <div data-part="lut-stats" class="svelte-1kasenj"> </div> <div data-part="lut-actions" class="svelte-1kasenj"><!></div></div></article>`);
var root_3 = $.from_html(`<div data-part="lut-add-item" class="svelte-1kasenj"><button type="button" data-part="lut-add-new" class="svelte-1kasenj"> </button> <button type="button" data-part="lut-add-browse" class="svelte-1kasenj"> </button></div>`);
var root_4 = $.from_html(`<div data-part="lut-add-item" class="svelte-1kasenj"><button type="button" data-part="lut-add-browse" class="single-action svelte-1kasenj"> </button></div>`);
var root_5 = $.from_html(`<!> <!>`, 1);
var root_6 = $.from_html(`<div data-lut-empty="true" class="svelte-1kasenj"> </div>`);
var root_7 = $.from_html(`<div class="lut-root svelte-1kasenj"><!> <input type="file" accept="image/*" multiple="" hidden=""/></div>`);

const $$css = {
	hash: 'svelte-1kasenj',
	code: '.lut-root.svelte-1kasenj {display:flex;gap:10px;overflow-x:auto;overflow-y:hidden;min-height:122px;padding:12px;padding-top:0;}[data-lut-empty="true"].svelte-1kasenj {width:100%;min-height:92px;border:1px dashed var(--color-panel-border-strong, #464646);border-radius:12px;display:grid;place-items:center;color:var(--color-muted);font-size:12px;}[data-lut-item="true"].svelte-1kasenj {flex:0 0 120px;aspect-ratio:1 / 1;border:1px solid var(--color-panel-border-strong, #464646);border-radius:12px;background:var(--color-surface-inset, #171c25);position:relative;cursor:grab;}[data-lut-item="true"][data-dragging="true"] {opacity:0.42;}[data-lut-item="true"][data-drop-position="before"] {box-shadow:-3px 0 0 var(--color-accent);}[data-lut-item="true"][data-drop-position="after"] {box-shadow:3px 0 0 var(--color-accent);}[data-part="lut-thumb-wrap"].svelte-1kasenj {position:absolute;inset:0;border-radius:inherit;overflow:hidden;}[data-part="lut-thumb"].svelte-1kasenj {width:100%;height:100%;display:block;object-fit:cover;}[data-part="lut-meta"].svelte-1kasenj {position:absolute;bottom:0;left:0;right:0;display:grid;grid-template-columns:1fr auto;grid-template-rows:auto auto;gap:2px;padding:5px 7px;background:color-mix(in srgb, var(--color-bg, #111111), transparent 28%);backdrop-filter:blur(3px);}[data-part="lut-name"].svelte-1kasenj {font-size:11px;line-height:1.35;color:var(--color-text-strong);overflow-wrap:anywhere;grid-row:1;grid-column:1 / -1;}[data-part="lut-stats"].svelte-1kasenj {font-size:10px;color:var(--color-muted);grid-row:2;}[data-part="lut-actions"].svelte-1kasenj {display:flex;gap:4px;align-items:stretch;justify-content:flex-end;grid-row:2;margin-top:auto;}.lut-remove-button {margin-top:auto;font-size:10px;padding:4px 7px;height:16px;box-sizing:content-box;}.lut-menu {z-index:200;min-width:110px;}.lut-remove-menu-item.svelte-1kasenj {color:var(--color-danger-text);}[data-part="lut-add-item"].svelte-1kasenj {flex:0 0 120px;display:flex;flex-direction:column;align-items:stretch;cursor:default;aspect-ratio:1 / 1;border:1px dashed var(--color-line);border-radius:12px;padding:0;overflow:hidden;}[data-part="lut-add-new"].svelte-1kasenj,\n  [data-part="lut-add-browse"].svelte-1kasenj {display:flex;align-items:center;justify-content:center;border:none;background:transparent;color:var(--color-muted);padding:0;font-size:12px;cursor:pointer;transition:120ms ease;}[data-part="lut-add-new"].svelte-1kasenj {flex:2 0 0;}[data-part="lut-add-browse"].svelte-1kasenj {flex:1 0 0;}[data-part="lut-add-browse"].single-action.svelte-1kasenj {flex:1 1 auto;}[data-part="lut-add-new"].svelte-1kasenj:hover,\n  [data-part="lut-add-browse"].svelte-1kasenj:hover {color:var(--color-accent);background:color-mix(in srgb, var(--color-surface-inset, #171c25), var(--color-accent) 8%);}'
};

export default function Svelte_lut_strip_list($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const luts = $.prop($$props, 'luts', 23, () => []),
		steps = $.prop($$props, 'steps', 23, () => []),
		canEditLut = $.prop($$props, 'canEditLut', 7, false),
		canDuplicateLut = $.prop($$props, 'canDuplicateLut', 7, false),
		canCreateNewLut = $.prop($$props, 'canCreateNewLut', 7, false);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let language = $.state($.proxy(getLanguage()));
	let fileInputRef = $.state(null);
	let scrollRoot = $.state(null);
	let frozenScrollLeft = $.state(null);
	const scrollState = { savedLeft: 0, restoring: false };

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	function isNonEmptyString(value) {
		return typeof value === 'string' && value.trim().length > 0;
	}

	function usageCount(lutId) {
		return steps().reduce((count, step) => step.lutId === lutId ? count + 1 : count, 0);
	}

	function handleRemoveLut(lutId) {
		if (!isNonEmptyString(lutId)) {
			dispatch('status-message', { message: tr('pipeline.lut.invalidId'), kind: 'error' });

			return;
		}

		dispatch('remove-lut', { lutId });
	}

	function restoreScrollPosition(targetLeft) {
		requestAnimationFrame(() => {
			if (!$.get(scrollRoot)) {
				return;
			}

			scrollState.restoring = true;
			scrollState.savedLeft = targetLeft;
			$.get(scrollRoot).scrollLeft = targetLeft;

			requestAnimationFrame(() => {
				if (!$.get(scrollRoot)) {
					scrollState.restoring = false;
					$.set(frozenScrollLeft, null);

					return;
				}

				$.get(scrollRoot).scrollLeft = targetLeft;
				scrollState.restoring = false;
				$.set(frozenScrollLeft, null);
			});
		});
	}

	function withPreservedScroll(action) {
		const targetLeft = $.get(frozenScrollLeft) ?? $.get(scrollRoot)?.scrollLeft ?? scrollState.savedLeft;

		action();
		restoreScrollPosition(targetLeft);
	}

	function freezeScrollPosition() {
		$.set(frozenScrollLeft, $.get(scrollRoot)?.scrollLeft ?? scrollState.savedLeft, true);
		scrollState.savedLeft = $.get(frozenScrollLeft);
	}

	function handleMenuClose() {
		if ($.get(frozenScrollLeft) === null) {
			return;
		}

		restoreScrollPosition($.get(frozenScrollLeft));
	}

	function openFilePicker() {
		if (!$.get(fileInputRef)) {
			dispatch('status-message', { message: tr('pipeline.lut.fileInputMissing'), kind: 'error' });

			return;
		}

		$.get(fileInputRef).click();
	}

	async function handleFileInputChange(event) {
		const input = event.currentTarget;

		if (!input) {
			dispatch('status-message', {
				message: tr('pipeline.lut.fileInputFetchFailed'),
				kind: 'error'
			});

			return;
		}

		const rawFiles = input.files;

		if (!rawFiles || rawFiles.length === 0) {
			input.value = '';

			return;
		}

		const files = Array.from(rawFiles);

		if (files.some((file) => !(file instanceof File))) {
			dispatch('status-message', {
				message: tr('pipeline.lut.fileInputInvalidValue'),
				kind: 'error'
			});

			input.value = '';

			return;
		}

		dispatch('add-lut-files', { files });
		input.value = '';
	}

	onDestroy(() => {
		disposeLanguageSync();
	});

	const structureKey = $.derived(() => `${luts().map((lut) => lut.id).join(',')}|${steps().map((step) => step.id).join(',')}|${Number(canEditLut())}|${Number(canDuplicateLut())}|${Number(canCreateNewLut())}`);

	$.user_effect(() => {
		$.get(structureKey);

		if (!$.get(scrollRoot)) {
			return;
		}

		const targetLeft = scrollState.savedLeft;

		if (Math.abs($.get(scrollRoot).scrollLeft - targetLeft) <= 1) {
			return;
		}

		requestAnimationFrame(() => {
			if (!$.get(scrollRoot)) {
				return;
			}

			scrollState.restoring = true;
			$.get(scrollRoot).scrollLeft = targetLeft;

			requestAnimationFrame(() => {
				if (!$.get(scrollRoot)) {
					scrollState.restoring = false;

					return;
				}

				$.get(scrollRoot).scrollLeft = targetLeft;
				scrollState.restoring = false;
			});
		});
	});

	var $$exports = {
		get luts() {
			return luts();
		},

		set luts($$value = []) {
			luts($$value);
			$.flush();
		},

		get steps() {
			return steps();
		},

		set steps($$value = []) {
			steps($$value);
			$.flush();
		},

		get canEditLut() {
			return canEditLut();
		},

		set canEditLut($$value = false) {
			canEditLut($$value);
			$.flush();
		},

		get canDuplicateLut() {
			return canDuplicateLut();
		},

		set canDuplicateLut($$value = false) {
			canDuplicateLut($$value);
			$.flush();
		},

		get canCreateNewLut() {
			return canCreateNewLut();
		},

		set canCreateNewLut($$value = false) {
			canCreateNewLut($$value);
			$.flush();
		}
	};

	var fragment = $.comment();
	var node = $.first_child(fragment);

	$.key(node, () => $.get(language), ($$anchor) => {
		var div = root_7();
		var node_1 = $.child(div);

		{
			var consequent_2 = ($$anchor) => {
				var fragment_1 = root_5();
				var node_2 = $.first_child(fragment_1);

				$.each(node_2, 17, luts, (lut) => lut.id, ($$anchor, lut) => {
					var article = root_2();

					$.set_attribute(article, 'draggable', true);

					var div_1 = $.child(article);
					var img = $.only_child(div_1);
					var div_2 = $.sibling(div_1, 2);
					var div_3 = $.child(div_2);
					var text = $.only_child(div_3, true);
					var div_4 = $.sibling(div_3, 2);
					var text_1 = $.only_child(div_4, true);
					var div_5 = $.sibling(div_4, 2);
					var node_3 = $.child(div_5);

					{
						var consequent = ($$anchor) => {
							{
								const trigger = ($$anchor) => {
									var span = root();

									$.append($$anchor, span);
								};

								const children = ($$anchor, closeMenu = $.noop) => {
									var fragment_3 = root_1();
									var button = $.first_child(fragment_3);
									var text_2 = $.only_child(button, true);
									var button_1 = $.sibling(button, 2);
									var text_3 = $.only_child(button_1, true);
									var button_2 = $.sibling(button_1, 2);
									var text_4 = $.only_child(button_2, true);

									$.template_effect(
										($0, $1, $2) => {
											$.set_text(text_2, $0);
											$.set_text(text_3, $1);
											$.set_text(text_4, $2);
										},
										[
											() => tr('pipeline.lut.edit'),
											() => tr('pipeline.lut.duplicate'),
											() => tr('pipeline.step.remove')
										]
									);

									$.delegated('click', button, () => {
										withPreservedScroll(() => {
											closeMenu()();
											dispatch('edit-lut', { lutId: $.get(lut).id });
										});
									});

									$.delegated('click', button_1, () => {
										withPreservedScroll(() => {
											closeMenu()();
											dispatch('duplicate-lut', { lutId: $.get(lut).id });
										});
									});

									$.delegated('click', button_2, () => {
										withPreservedScroll(() => {
											closeMenu()();
											handleRemoveLut($.get(lut).id);
										});
									});

									$.append($$anchor, fragment_3);
								};

								let $0 = $.derived(() => tr('pipeline.lut.kebabAria', { name: $.get(lut).name }));

								DropdownMenu($$anchor, {
									wrapperClass: 'ui-menu-wrap',
									menuClass: 'ui-menu lut-menu',
									get triggerAriaLabel() {
										return $.get($0);
									},
									menuRole: 'menu',
									triggerVariant: 'menu-trigger',
									floating: true,
									onOpen: freezeScrollPosition,
									onClose: handleMenuClose,
									trigger,
									children,
									$$slots: { trigger: true, default: true }
								});
							}
						};

						var alternate = ($$anchor) => {
							{
								let $0 = $.derived(() => tr('pipeline.lut.removeAria', { name: $.get(lut).name }));

								Button($$anchor, {
									variant: 'destructive',
									className: 'lut-remove-button',
									id: undefined,
									handlePress: () => handleRemoveLut($.get(lut).id),
									get ariaLabel() {
										return $.get($0);
									},

									children: ($$anchor, $$slotProps) => {
										$.next();

										var text_5 = $.text();

										$.template_effect(($0) => $.set_text(text_5, $0), [() => tr('pipeline.step.remove')]);
										$.append($$anchor, text_5);
									},
									$$slots: { default: true }
								});
							}
						};

						$.if(node_3, ($$render) => {
							if ($.get(lut).ramp2dData && (canEditLut() || canDuplicateLut())) $$render(consequent); else $$render(alternate, -1);
						});
					}

					$.reset(div_5);
					$.reset(div_2);
					$.reset(article);

					$.template_effect(
						($0) => {
							$.set_attribute(article, 'data-lut-id', $.get(lut).id);
							$.set_attribute(img, 'src', $.get(lut).thumbUrl);
							$.set_attribute(img, 'alt', `${$.get(lut).name} thumbnail`);
							$.set_text(text, $.get(lut).name);
							$.set_text(text_1, $0);
						},
						[
							() => tr('pipeline.lut.stats', {
								width: $.get(lut).width,
								height: $.get(lut).height,
								count: usageCount($.get(lut).id)
							})
						]
					);

					$.append($$anchor, article);
				});

				var node_4 = $.sibling(node_2, 2);

				{
					var consequent_1 = ($$anchor) => {
						var div_6 = root_3();
						var button_3 = $.child(div_6);
						var text_6 = $.only_child(button_3, true);
						var button_4 = $.sibling(button_3, 2);
						var text_7 = $.only_child(button_4, true);

						$.reset(div_6);

						$.template_effect(
							($0, $1, $2, $3) => {
								$.set_attribute(button_3, 'aria-label', $0);
								$.set_text(text_6, $1);
								$.set_attribute(button_4, 'aria-label', $2);
								$.set_text(text_7, $3);
							},
							[
								() => tr('lutEditor.newLutAria'),
								() => tr('lutEditor.newLut'),
								() => tr('pipeline.lut.browseAria'),
								() => tr('pipeline.lut.browse')
							]
						);

						$.delegated('click', button_3, () => dispatch('new-lut'));
						$.delegated('click', button_4, openFilePicker);
						$.append($$anchor, div_6);
					};

					var alternate_1 = ($$anchor) => {
						var div_7 = root_4();
						var button_5 = $.child(div_7);
						var text_8 = $.only_child(button_5, true);

						$.reset(div_7);

						$.template_effect(
							($0, $1) => {
								$.set_attribute(div_7, 'title', $0);
								$.set_text(text_8, $1);
							},
							[() => tr('pipeline.lut.add'), () => tr('pipeline.lut.add')]
						);

						$.delegated('click', button_5, openFilePicker);
						$.append($$anchor, div_7);
					};

					$.if(node_4, ($$render) => {
						if (canCreateNewLut()) $$render(consequent_1); else $$render(alternate_1, -1);
					});
				}

				$.append($$anchor, fragment_1);
			};

			var alternate_2 = ($$anchor) => {
				var div_8 = root_6();
				var text_9 = $.only_child(div_8, true);

				$.template_effect(($0) => $.set_text(text_9, $0), [() => tr('pipeline.lut.empty')]);
				$.append($$anchor, div_8);
			};

			$.if(node_1, ($$render) => {
				if (luts().length > 0) $$render(consequent_2); else $$render(alternate_2, -1);
			});
		}

		var input_1 = $.sibling(node_1, 2);

		$.bind_this(input_1, ($$value) => $.set(fileInputRef, $$value), () => $.get(fileInputRef));
		$.reset(div);
		$.bind_this(div, ($$value) => $.set(scrollRoot, $$value), () => $.get(scrollRoot));

		$.event('scroll', div, () => {
			if (!$.get(scrollRoot) || scrollState.restoring || $.get(frozenScrollLeft) !== null) {
				return;
			}

			scrollState.savedLeft = $.get(scrollRoot).scrollLeft;
		});

		$.delegated('change', input_1, (event) => void handleFileInputChange(event));
		$.append($$anchor, div);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click', 'change']);

customElements.define('lut-lut-strip-list', $.create_custom_element(
	Svelte_lut_strip_list,
	{
		luts: {},
		steps: {},
		canEditLut: {},
		canDuplicateLut: {},
		canCreateNewLut: {}
	},
	[],
	[]
));